module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer-div outer-div-heavy"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "center width_full"
  }, [_c('h3', {
    staticClass: "black-text"
  }, [_vm._v("Profile Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "manufacture"
    }
  }, [_vm._v("Manufacturer:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.manufacturer),
      expression: "profile.manufacturer"
    }],
    staticClass: "dark-grey-text",
    attrs: {
      "type": "text",
      "readonly": true
    },
    domProps: {
      "value": (_vm.profile.manufacturer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.manufacturer = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "refName"
    }
  }, [_vm._v("Representative Name:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.name),
      expression: "profile.name"
    }],
    staticClass: "dark-grey-text",
    class: {
      error: _vm.validationMessages.name.length || _vm.validationMessages.name.format
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.name)
    },
    on: {
      "keyup": function($event) {
        _vm.validator(_vm.profile.name, "name")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.validationMessages.name.length) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.validationMessages.name.length))]) : _vm._e(), _vm._v(" "), (!_vm.validationMessages.name.length && _vm.validationMessages.name.format) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.validationMessages.name.format))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "repPhone"
    }
  }, [_vm._v("Representative Phone:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.phone),
      expression: "profile.phone"
    }],
    staticClass: "dark-grey-text",
    class: {
      error: _vm.validationMessages.phone.length || _vm.validationMessages.phone.format
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.phone)
    },
    on: {
      "keyup": function($event) {
        _vm.validator(_vm.profile.phone, "phone")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.validationMessages.phone.length) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.validationMessages.phone.length))]) : _vm._e(), _vm._v(" "), (!_vm.validationMessages.phone.length && _vm.validationMessages.phone.format) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.validationMessages.phone.format))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "refEmail"
    }
  }, [_vm._v("Representative Email:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "dark-grey-text",
    class: {
      error: _vm.validationMessages.email.length || _vm.validationMessages.email.format
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "keyup": function($event) {
        _vm.validator(_vm.profile.email, "email")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.validationMessages.email.length) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.validationMessages.email.length))]) : _vm._e(), _vm._v(" "), (!_vm.validationMessages.email.length && _vm.validationMessages.email.format) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.validationMessages.email.format))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "submit-pane"
  }, [_c('button', {
    staticClass: "dark-grey-bg width_full",
    attrs: {
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": _vm.editDetails
    }
  }, [_vm._v(_vm._s(_vm.text) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e07f5a4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Profile.vue
// module id = 383
// module chunks = 2